import script from "./FluxForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FluxForm.vue?vue&type=script&setup=true&lang=js"

import "./FluxForm.vue?vue&type=style&index=0&id=26f865ff&lang=css"

const __exports__ = script;

export default __exports__